import type { TaskBucket } from '../schemas/task'

export type PriorityGroupMeta = {
  id: TaskBucket
  title: string
  accentColor: string
  accentBg: string
}

export const PRIORITY_GROUPS: PriorityGroupMeta[] = [
  { id: 'urgent', title: 'Urgent', accentColor: '#cf1322', accentBg: '#fff1f0' },
  { id: 'week', title: 'Cette semaine', accentColor: '#c2410c', accentBg: '#fff7ed' },
  { id: 'later', title: 'Plus tard', accentColor: '#0958d9', accentBg: '#e6f4ff' },
  { id: 'waiting', title: 'En attente', accentColor: '#531dab', accentBg: '#f9f0ff' },
  { id: 'ignored', title: 'Ignoré', accentColor: 'rgba(0,0,0,0.45)', accentBg: '#f5f5f5' },
]

export const DEFAULT_EXPANDED: Record<TaskBucket, boolean> = {
  urgent: true,
  week: true,
  later: false,
  waiting: false,
  ignored: false,
}
